import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../Assets/img/logo-small.png';


const Otpverification = () => {
  const [otp, setOtp] = useState(['', '', '', '',]);
  const [isSubmitButtonEnabled, setIsSubmitButtonEnabled] = useState(false);
  const navigate = useNavigate();

const handleOtpChange = (e, index) => {
  const newOtp = [...otp];
  const inputValue = e.target.value;

  // Update the OTP array with the new value
  newOtp[index] = inputValue;
  setOtp(newOtp);

  // Check if the input value's length is 1 (meaning a digit is entered)
  if (inputValue.length === 1) {
  
    if (index === otp.length - 1) {
      const isOtpComplete = newOtp.every((value) => value !== '');
      setIsSubmitButtonEnabled(isOtpComplete);
    }
    const nextInput = e.target.nextElementSibling;
    if (nextInput) {
      nextInput.focus();
    }
  }
  else{

    const prevInput = e.target.previousElementSibling;
    if (prevInput) {
      prevInput.focus();
    }

  }

  const isOtpComplete = newOtp.every((value) => value !== '');
  setIsSubmitButtonEnabled(isOtpComplete);
};

const handleSubmit = (e) => {
  e.preventDefault();

  const otpString = otp.join('');

  const isValidOtp = /^\d{4}$/.test(otpString);

  if (isValidOtp) {
   
    // console.log('Valid OTP:', otpString);
    navigate('/profile');
   
  } else {
  
    console.log('Invalid OTP');
    
  }
};

return (
  <div className='body23'>
  <div className="container23">
    <div className="login-box23">
      <div className="circle23">
        <img className="img-fluid for-light" src={logo} alt="MGU Logo" />
      </div>
      <div className='heading12'>Enter Your OTP</div>
      <form onSubmit={handleSubmit} className="form12">
        <div className="input-field123">
          <input
            type="text"
            value={otp[0]}
            onChange={(e) => handleOtpChange(e, 0)}
            maxLength={1}
            pattern="\d*"
          />
          <input
            type="text"
            value={otp[1]}
            onChange={(e) => handleOtpChange(e, 1)}
            maxLength={1}
            pattern="\d*"
          />
          <input
            type="text"
            value={otp[2]}
            onChange={(e) => handleOtpChange(e, 2)}
            maxLength={1}
            pattern="\d*"
          />
          <input
            type="text"
            value={otp[3]}
            onChange={(e) => handleOtpChange(e, 3)}
            maxLength={1}
            pattern="\d*"
          />
        </div>
        <button
          type="submit"
          className="submit-btn23"
          style={{ width: '50%' }}
          disabled={!isSubmitButtonEnabled}
        >
          Validate
        </button>
      </form>
    </div>
  </div>
  </div>
);
};

export default Otpverification;